import { useDispatch } from 'react-redux';
import { clearRestockSubscribe } from '@client/product/redux/restockSubscribe/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export const useClearRestockSubscribeAction = (): typeof clearRestockSubscribe => {
  const dispatch = useDispatch();

  return bindActionCreators(clearRestockSubscribe, dispatch);
};
